<script lang="ts" setup>
import { getToken } from '@firebase/messaging';
import Swal from "sweetalert2";
import type { Messaging, NotificationPayload } from '@firebase/messaging';
// import { useToast } from "vue-toastification";
// import Toast from "vue-toastification";
import { useToast } from "vue-toastification";

const toast = useToast();
const userStore = useUserStore();
// const ppobStore = usePPOBStore();
// const route = useRoute();
onMounted(() => {
  if (!window.Notification) return;

  if (window.Notification.permission === 'granted') {
    setToken();
  } else {
    window.Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        setToken();
      }
    });
  }
});

const setToken = async () => {
  const { $messaging, $onMessageListener } = useNuxtApp();

  try {
    const token = await getToken($messaging as Messaging, {
      vapidKey: 'BO0ZME9wbucnI7MbzyRA43JPhS1CrNldc8RAfmNX-jHWME7dIcXmDI-KyIB8nFK1uKKh29MS8nPFA0raMcmpWUQ',
    });

    console.log('Token:', token);

    localStorage.setItem('fcmToken', token);

    ($onMessageListener as (callback: (payload: { notification: { title: any; body: any; }; }) => void) => void)((payload: { notification: { title: any; body: any; }; }) => {
      if (payload.notification) {
        console.log('Foreground message:', payload);

        const { title, body } = payload.notification;
        const url = payload.data?.url;
        const service = payload.data?.id;
        
        // if(service == 6){
        //   if (route.path === "/ppob/reports") {
        //   }

        // }

        toast.info({
          component: h('div', { style: "cursor: pointer;", onClick: () => handleClick(url) }, [
            h('strong', {}, title ? title : 'Info'),
            h('p', {}, body)
          ]),
          timeout: 5000,
          closeOnClick: true
        });

        userStore.fetchUserBalance()
      }
    });
  } catch (err) {
    console.error('Error in setToken:', err);
  }
};

const handleClick = (url: string) => {
  if (url) {
    console.log("Opening in new tab:", url);
    window.open(url, "_blank"); 
  }
};
</script>
<template>
  <div>
    <NuxtLoadingIndicator />
    <NuxtPage />
  </div>
</template>
